import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'form-error',
  template: `
    <div *ngIf="control.errors && control.touched">
      <ng-container *ngFor="let validator of validators">
        <p *ngIf="control.hasError(validator.name)">
          {{ validator.message }}
        </p>
      </ng-container>
    </div>
  `,
})
export class FormErrorComponent {
  @Input() control: AbstractControl;
  @Input() validators: { name: string; message: string }[];
}
